module.exports = __webpack_public_path__ + "static/media/objects2_24.1689cdd7.svg";